import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from "@angular/common";

@Pipe({
    name: 'dateFormat',
    standalone: true
})
export class DateFormatPipe extends DatePipe implements PipeTransform {
    date: Date = new Date();

    override transform(value: any, format?: any): any {
        return super.transform(value.substring(0, 23) + 'Z', format ? format : 'dd/MM/yyyy', this.getTimezone());
    }

    getTimezone(): string {
        let differenceInHours = this.date.getTimezoneOffset() / -60;
        let lessThanUtc = differenceInHours.toString().includes('-');
        return `UTC ${lessThanUtc ? differenceInHours : `+${differenceInHours}`}`;
    }
}